import {Link} from 'react-router-dom';
import {useSettings} from '../../../core/settings/use-settings';

export function AuthLayoutFooter() {
  const {branding} = useSettings();
  return (
    <div className="pt-42 pb-32 flex items-center gap-30 text-sm text-muted mt-auto">
      <Link className="hover:text-fg-base transition-colors" to="/">
        © {branding.site_name}
      </Link>
      <Link to="/pages/about-us">Tentang Kami</Link>
      <Link to="/pages/privacy-policy">Notis Privasi</Link>
      <Link to="/pages/terms-of-service">Terma Perkhidmatan</Link>
    </div>
  );
}
